import React from 'react'
import cv from '../assets/info/IsmaelCV.pdf';
function Principal() {

  function onResumeClick() {
    window.open(cv);
  }
  return (
    <div id="home" className=" flex justify-center flex-col text-5xl p-6 h-screen dark:bg-black scroll-mt-20 px-4">
      <h2 className="dark:text-white mx-12 text-6xl sm:text-6xl text-center sm:text-left">
        <p className="font-mono text-2xl my-4 sm:text-4xl text-left sm:text-left">Hi, my name is  <span className="textBrilliant">Ismael Hernandez</span></p>
      
      I am a <span className="textBrilliant">Full Stack Developer</span> of web applications and websites.
      </h2>
      <div className="m-8">
        <button className="bg-green rounded-md p-4 text-white text-center w-full sm:w-1/4 ease-in-out duration-300 hover:bg-green3 text-3xl sm:text-2xl" onClick={onResumeClick}>Download my CV</button>
      </div>
    </div>
  )
}

export default Principal